module.exports = {"652822100":"轮台镇","652822101":"轮南镇","652822102":"群巴克镇","652822103":"阳霞镇","652822201":"哈尔巴克乡","652822202":"野云沟乡","652822203":"阿克萨来乡","652822204":"塔尔拉克乡","652822205":"草湖乡","652822206":"铁热克巴扎乡","652822207":"策达雅乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652822.json
// module id = 2867
// module chunks = 0